import { Factory } from 'rosie';
import './lib/uuid';

Factory.define('FbMessageOutgoingAttachment').extend('Uuid');

Factory.define('FbMessageOutgoingAttachmentWithDefaults')
  .extend('FbMessageOutgoingAttachment')
  .attr('contentType', 'text/plain')
  .attr('filename', 'some-outgoing-facebook-attachment.txt');
